<template>
  <div>
    <ul
      class="fixed bottom-20 md:bottom-28 right-5 md:right-8 z-10 info-box"
      v-if="showModal"
    >
      <el-tooltip content="Visit the Help Center" placement="top">
        <li @click="openHelpCenter">Visit the Help Center <link-icon /></li>
      </el-tooltip>

      <li
        v-if="tourIsEnabled && !isMobileDashboardPage"
        @click="startWalkThrough"
      >
        See Walkthrough <arrow-icon size="h-6 w-6" color="#5D5E68" />
      </li>
    </ul>

    <button
      @click="openModal"
      class="fixed bottom-5 md:bottom-10 right-5 md:right-8 h-12 w-12 info-icon"
    >
      <info-icon />
    </button>

    <div
      v-if="showModal"
      @click="closeModal"
      class="fixed inset-0 w-full h-full"
    ></div>
  </div>
</template>

<script>
import tourIsEnabled from '@/mixins/appTourApi.js'
import breakpoints from '@/utils/breakpoints.js'

export default {
  mixins: [tourIsEnabled],
  components: {
    InfoIcon: () => import('@/assets/v2/icons/InfoIcon3.vue'),
    ArrowIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    LinkIcon: () => import('@/assets/v2/icons/LinkIcon.vue')
  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
    helpDeskUrl () {
      let url
      switch (process.env.VUE_APP_TENANT_NAME) {
        case 'oval':
          url = 'https://ovalfi.atlassian.net/servicedesk/customer/portals'
          break
        case 'torus':
          url = 'https://torusmara.atlassian.net/servicedesk/customer/portals'
          break
        case 'tma':
          url = 'https://ovalfi.atlassian.net/servicedesk/customer/portals'
          break
        default:
          url = 'https://ovalfi.atlassian.net/servicedesk/customer/portals'
      }

      return url
    },
    isMobileDashboardPage () {
      return (
        breakpoints.mdAndDown && window.location.pathname.includes('dashboard')
      )
    }
  },
  methods: {
    openModal () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    startWalkThrough () {
      this.showModal = false
      this.$emit('startTour')
    },
    openHelpCenter () {
      this.showModal = false
      window.open(this.helpDeskUrl, '_blank', 'noreferrer', 'noopenner')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eeeeee;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0px 20px 24px 1px rgba(3, 2, 7, 0.168);
}

.info-box {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 24px 1px rgba(3, 2, 7, 0.168);
  font-weight: 500;

  li {
    font-size: 14px;
    padding: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;

    &:first-child {
      border-bottom: 1px solid #eeeeee;
    }

    &:hover {
      background-color: #ebf2ff;

      &:first-child {
        border-radius: 8px 8px 0 0;
      }
      &:last-child {
        border-radius: 0 0 8px 8px;
      }
    }
  }
}
</style>
